import styled, { keyframes } from 'styled-components'

export const animate = keyframes`
    0% {
        transform: scale(1);
    }
    90% {
        transform: scale(1.5);
    }
    100% {
        transform: scale(2);
        opacity: 0;
    }
`

export const Wrapper = styled.div`
    position: absolute;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background: #3f3f3f;
    z-index: -2;
    display: flex;
    justify-content: center;
    align-items: center;
`

export const Pulse = styled.span`
    margin: auto;
    position: absolute;
    background: #3f3f3f;
    border-radius: 50%;
    display: inline-block;
    width: 100%;
    height: 100%;
    transition: transform 0.5s ease;
`
export const Ring = styled.span`
    position: absolute;
    top: 0;
    left: 0;
    background: transparent;
    border-radius: 50%;
    border: 4px solid #3f3f3f;
    display: inline-block;
    width: ${props => props.size}px;
    height: ${props => props.size}px;
    animation: ${animate} 2.5s linear infinite;
    animation-delay: calc(-0.5s);
`

export const MobileWrapper = styled.div`
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background: transparent;
    z-index: 2;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 3px solid #27ae60;
`

export const ActiveMicImage = styled.img`
    position: absolute;
    bottom: -8px;
    left: calc(50% - 8px);
`
